import React from "react";
import { v4 as uuidv4 } from "uuid";

import moment from 'moment';
import "../styles/jogoRifa.scss";
import { R$ } from "../utils/brl";
import Icon from "./layout/icon";
import { CalendarBlank, WhatsappLogo, TwitterLogo, FacebookLogo, TelegramLogo } from "phosphor-react";

import {
  setDisabledNumbers,
  setLoading,
  setGUID,
  setCart,
} from "../../reducers/rifa/rifaActions";
import Container from "./layout/container";
import { doRequest } from "../../modules/request";
import { CONTEST_API } from "../../modules/constants";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RifaInfoCard from "./rifaInfoCard";
import SelectDate from "./selectDate";
import SelectNumbersRifa from "./selectNumbers";
import SelectDuesRifa from "./selectDues";
import SelectBicho from "./selectBicho";
import { forceInt } from "../../utils/forceInt";
import { emitIntent } from "../../newDesign/utils/emitIntent";

import {
  AnalyticsSetGameStep,
  AnalyticsSetFinishPurchase
} from "../../reducers/analytics/analyticsActions";

class JogoRifa extends React.Component {
  constructor(props) {
    super(props);

    /**
     * @type {{
     * cart: {
     *  number: number,
     *  value: number,
     *  amount: number
     * }[],
     * date: number
     * }}
     */
    this.state = {
      cart: [],
      date: 0,
      disabledNumbers: []
    };

    /**
     * @type {{
     *  onReturn: () => void,
     *  onConfirm: (cart: any[], date: string, gameTypeId: number, extractionId: number) => Promise<any>,
     *  sendDueBet: (data: any)
     *  rifa: {
     *      title: string,
     *      description: string,
     *      numberAmount: number,
     *      numberLength: number,
     *      image: string,
     *      value: number,
     *      prize: number,
     *      raffleTime: string,
     *      dateOptions: string[],
     *      extractionId: number,
     *      gameTypeId: number,
     *      isBicho: boolean
     *  }
     * }}
     */
    this.props;

    this.selectDate = this.selectDate.bind(this);
    this.finishBet = this.finishBet.bind(this);
    this.finishDueBet = this.finishDueBet.bind(this);
  }

  getUsedNumbers() {
    if (this.props.rifa.isTotalSalesCalculation || this.props.rifa.tipo === "com-validacao") {
      const dateStr = this.props.rifa.dateOptions[this.state.date];
      const params = {
        url: CONTEST_API + "JBWeb.svc/GetNumerosRifa",
        method: "POST",
        data: {
          Cliente_ID: this.props.user.Cliente_ID,
          Site_ID: forceInt(this.props.user.Site_ID),
          CID: this.props.user.CID,
          chrSerial: this.props.user.ChrSerial,
          Rifa_ID: this.props.rifa.id,
          strData: dateStr,
        },
      };

      const numberLength = Math.floor(Math.log10(this.props.rifa.numberAmount) - 1) + 1;

      new Promise((resolve, reject) => {
        doRequest(params)
          .then((response) => {
            if (response.intCodigoRetorno > 0) {
              this.props.toggleErrorModal("Atenção", response.strErrorMessage);
            } else {
              this.setState({
                ...this.state,
                disabledNumbers: response.arrNumerosRifa.reduce((obj, reserva) => {
                  const key = reserva.intNumero.toString().padStart(numberLength, "0");
                  return { ...obj, [key]: true };
                }, {})
              })
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  }

  componentWillMount() {
    this.props.setGUID(uuidv4());
    this.props.setDisabledNumbers({});

    this.getUsedNumbers();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.date !== prevState.date) {
      this.getUsedNumbers();
    }
  }

  selectDate(index) {
    this.setState({
      ...this.state,
      date: index,
    });
  }

  isNumberSelected(number) {
    return !!this.state.cart.find((bet) => bet.number == number);
  }

  finishDueBet({ valorTotal, amount, isPreTicket = false, isPix = false }, clearCartCallback) {
    this.props.AnalyticsSetGameStep('Start Payment');
    this.props.setLoading(true);
    const { date: dateIndex } = this.state;
    const { rifa, strGuidWeb } = this.props;

    const { extractionId, dateOptions, id, game } = rifa;
    const dateStr = dateOptions[dateIndex];

    this.props
      .sendDueBet({
        extractionId: extractionId,
        valorTotal: valorTotal,
        valor: rifa.value,
        intQtdNumeros: amount,
        date: dateStr,
        rifaId: id,
        sntTipoJogoSistema: game.sntTipoJogoSistema,
        sntTipoJogo: game.sntTipoJogo,
        numberLength: rifa.numberLength,
        strGuidWeb,
        isPreTicket,
        isPix,
        clearCartFn: clearCartCallback
      })
      .then((res) => {
        this.props.AnalyticsSetFinishPurchase(valorTotal);
      })
      .catch((err) => {
        console.error(err);
        showError(err);
      })
      .finally(() => {
        this.props.setLoading(false);
      });

    function showError(err) {
      console.error(err);
    }
  }

  finishBet({ cart }, callback, isPreTicket = false, isPix = false) {
    this.props.AnalyticsSetGameStep('Start Payment');
    this.props.setLoading(true);

    const { date: dateIndex } = this.state;
    const { rifa, strGuidWeb } = this.props;

    const {
      tipo,
      gameTypeId,
      extractionId,
      selectedPrizes,
      dateOptions,
      id,
      prize,
      game,
      value,
    } = rifa;

    const dateStr = dateOptions[dateIndex];

    const numberLength = Math.floor(Math.log10(rifa.numberAmount - 1)) + 1;

    this.props
      .onConfirm({
        cart,
        dateStr,
        tipo,
        gameTypeId,
        extractionId,
        prize,
        selectedPrizes,
        id,
        sntTipoJogoSistema: game.sntTipoJogoSistema,
        numberLength,
        strGuidWeb,
        valor: value,
        isPreTicket: isPreTicket,
        isPix: isPix,
      })
      .then((res) => {
        this.props.AnalyticsSetFinishPurchase(value);
        if (this.props.rifa.isTotalSalesCalculation || this.props.rifa.tipo === "com-validacao") {
          this.getUsedNumbers();
        }
        callback(true, isPreTicket, isPix);
      })
      .catch((err) => {
        console.error(err);
        showError(err);
      })
      .finally(() => {
        this.props.setLoading(false);
      });

    function showError(err) {
      this.props.toggleErrorModal("Erro", err.message);
      console.error(err);
    }
  }

  calculateAvailableQuotas() {
    const actualPercent = (this.state.disabledNumbers.length * 100) / this.props.rifa.numberAmount;
    const availablePercent = 100 - actualPercent;
    const availableCeil = Math.ceil(availablePercent);
    if (this.props.rifa.isTotalSalesCalculation) {
      return availableCeil;
    }
    return false;
  }

  scrollTop() {
    window && window.scrollTo({ top: 0 });
  }

  render() {
    const {
      title,
      description,
      shortDescription,
      image,
      value,
      prize,
      raffleTime,
      raflleBlockTime,
      dateOptions,
      extractionId,
      id,
      endSales,
    } = this.props.rifa;
    const { loading, session } = this.props;

    const isBicho = this.props.isBicho;

    const infoCard = <RifaInfoCard
      title={title}
      description={description}
      image={image}
      value={value}
      prize={prize}
      raffleTime={raffleTime}
      dateOptions={dateOptions}
      minimumAvailableQuotas={this.props.rifa.minimumAvailableQuotas}
      hideImage={this.props.rifa.tipo === "sorteio"}
      hideTitle={this.props.rifa.tipo === "sorteio"}
      hideDetails={this.props.rifa.tipo === "sorteio"}
    />

    function scrollQuotas() {
      const target = document.querySelector(".rifa-due");
      if(!target) return;
      const top = Math.floor(target.getBoundingClientRect().top - 100);
      emitIntent("scroll_window", { top })
    }

    function share(social) {
      const domain = (window.location != window.parent.location)
        ? document.referrer
        : document.location.href;
        
      const openExternalUrl = (url) => emitIntent("open_window", { url, target: "_blank" });

      switch(social) {
        case "facebook":
          openExternalUrl(`https://www.facebook.com/sharer/sharer.php?u=${domain}&quote=${title}`);
        break;
        case "twitter":
          openExternalUrl(`https://twitter.com/intent/tweet?url=${domain}&text=${title}`);
        break;
        case "whatsapp":
          openExternalUrl(`https://wa.me/?text=${title}%0A%0A${domain}`);
        break;
        case "telegram":
          openExternalUrl(`https://t.me/share?text=${title}&url=${domain}`);
        break;
      }
    }

    const blockDate =  new Date(`${dateOptions[0].split(' ')[0]} ${raflleBlockTime}`);
    const endingTagMessage = moment().diff(moment(blockDate), 'minutes') >= -120 ? "hurry-up" : "acquire-now";
    
    return (
      <React.Fragment>
        <Container>
          <section class="root">
            <div
              className="rifa-go-back-button"
              onClick={() => { this.props.setCart([]); this.props.onReturn(); }}
            >
              <Icon type="arrow-left" color="main" style={{stroke: "currentColor"}} />
              Voltar
            </div>

            {/* Rifa de Cotas */}
            { this.props.rifa.tipo === "sorteio" 
              ? <React.Fragment>
                  <div className="raffle-top-card">
                    <div className="raffle-top-card__image-wrapper">
                      { endingTagMessage === "hurry-up"
                        ? <p><span className="rifa-ending__message hurry-up">Corre que está acabando!</span></p>
                        : <p><span className="rifa-ending__message" style={{backgroundColor: "var(--primary)", color: "var(--light)"}}>Adquira já</span></p>
                      }
                      <img draggable={false} src={image} className="game-info__image full-rounded" onClick={scrollQuotas} />
                    </div>
                    <h1 className="game-info__text__title rifa-title mt-4 mb-6">{title}</h1>
                    { shortDescription ? <p>{shortDescription}</p> : null }
                  </div>

                  <p className="raffle-bet-value"><span className="raffle-bet-value__label">POR APENAS</span><span className="raffle-bet-value__value-box">{R$(value)}</span></p>

                  <div className="raffle-flex-between-card">
                    <p className="raffle-date-info">
                      <span className="raffle-date-info__date-box"><span className="raffle-date-info__label"><CalendarBlank size={12} /> Sorteio</span> <span className="raffle-date-info__value">{moment(dateOptions[0]).format('DD/MM/YYYY')} às {raffleTime}</span></span>
                    </p>
                    <div className="raffle-social-sharing-holder">
                      <small className="sharing-label">Compartilhar</small>
                      <div className="raffle-social-sharing">
                        <span className="i-bg facebook" onClick={() => share("facebook")}><FacebookLogo weight="regular" size={20} color="white" enableBackground={true} /></span>
                        <span className="i-bg twitter" onClick={() => share("twitter")}><TwitterLogo weight="regular" size={20} color="white" /></span>
                        <span className="i-bg telegram" onClick={() => share("telegram")}><TelegramLogo weight="regular"  size={20} color="white" /></span>
                        <span className="i-bg whatsapp" onClick={() => share("whatsapp")}><WhatsappLogo weight="regular" size={20} color="white" /></span>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              : infoCard }

            {extractionId && dateOptions && !!dateOptions.length && (
              <React.Fragment>
                  {this.props.rifa.tipo === "sorteio" ? (
                    <SelectDuesRifa
                      rifa={this.props.rifa}
                      calculateAvailableQuotas={this.calculateAvailableQuotas()}
                      finishBet={({ valorTotal, amount, isPreTicket, isPix }, cb) => {
                        this.finishDueBet({
                          valorTotal,
                          extractionId,
                          id,
                          amount,
                          isPreTicket,
                          isPix
                        }, cb);
                      }}
                      betValue={value}
                      minimumAvailableQuotas={this.props.rifa.minimumAvailableQuotas}
                      showError={this.props.toggleErrorModal}
                      session={session}
                    />
                ) : null}
                {this.props.rifa.tipo !== "sorteio" && (isBicho ?
                  <SelectBicho
                    calculateAvailableQuotas={this.calculateAvailableQuotas()}
                    disabledNumbers={this.state.disabledNumbers}
                    finishBet={(payload, cb, isPreTicket, isPix) => this.finishBet(payload, cb, isPreTicket, isPix)}
                    loading={loading}
                    rifa={this.props.rifa}
                    minimumAvailableQuotas={this.props.rifa.minimumAvailableQuotas}
                  /> : (
                    <SelectNumbersRifa
                      calculateAvailableQuotas={this.calculateAvailableQuotas()}
                      disabledNumbers={this.state.disabledNumbers}
                      finishBet={(payload, cb, isPreTicket, isPix) => this.finishBet(payload, cb, isPreTicket, isPix)}
                      loading={loading}
                      rifa={this.props.rifa}
                      minimumAvailableQuotas={this.props.rifa.minimumAvailableQuotas}
                    />
                  ))}
              </React.Fragment>
            )}

           { this.props.rifa.tipo === "sorteio" ? infoCard : null }

          </section>
        </Container>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.usuario.objUser,
  disabledNumbers: state.rifa.disabledNumbers,
  loading: state.rifa.loading,
  strGuidWeb: state.rifa.strGuidWeb,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setDisabledNumbers,
      setLoading,
      setGUID,
      setCart,
      AnalyticsSetGameStep,
      AnalyticsSetFinishPurchase,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(JogoRifa);



// WEBPACK FOOTER //
// ./src/rifa/components/jogoRifa.jsx